export default __webpack_public_path__ + "static/media/lupa.4f3739ee.svg";